import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import Select from "react-select";

const EditAreaModal = ({ isOpen, toggle, formData, setformData, moduleOptions, allCordinates, handleSaveINFO }) => { 
    const handleInput = (e) => {
        console.log(e.target.value)
        const { name, value } = e.target
        setformData({
            ...formData,
            [name]: value
        })
    }
    const roiOptions = allCordinates?.map((item, index) => ({
        ...item,
        name: item.name,
        label: item.name,
        value: item.id
    }));

    const levelOptions = [
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' }
    ];
    const colorOptions = [
        { value: 'no color', label: 'No Color' }, 
        { value: 'red', label: 'Red' },
        { value: 'blue', label: 'Blue' },
        { value: 'green', label: 'Green' },
        { value: 'yellow', label: 'Yellow' }, 
    ];
    const cameraBrandOptions = [
        { value: "canon", label: "Canon" },
        { value: "nikon", label: "Nikon" },
        { value: "sony", label: "Sony" },
        { value: "dahua", label: "Dahua" },
        { value: "hikvision", label: "Hikvision" }
    ];
    

    const handleROIChange = (selectedOptions) => { 
        setformData((prevData) => ({
            ...prevData,
            roi: selectedOptions
        }));
        
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Edit Area Information</ModalHeader>
            <ModalBody>
                <Form>
                    <Row>
                        <Col xs='12'>
                            <FormGroup>
                                <Label>Model Name</Label>
                                <Input type="text" name="model" value={formData?.model} readOnly />
                            </FormGroup>
                        </Col>
                        <Col md='6'>
                            <FormGroup  >
                                <Label>Start Time</Label>
                                <Input type="time" name="start_time" value={formData?.start_time} onChange={(e) => handleInput(e)} />
                            </FormGroup>
                        </Col>
                        <Col md='6'>
                            <FormGroup  >
                                <Label>End Time</Label>
                                <Input type="time" name="end_time" value={formData?.end_time} onChange={(e) => handleInput(e)} />
                            </FormGroup>
                        </Col> 
                        <Col md="6">
                            <FormGroup>
                                <Label>Colour</Label>
                                <Select 
                                    options={colorOptions} 
                                    value={colorOptions.find(option => option.value === formData.color)}
                                    onChange={selectedOption => setformData({ ...formData, color: selectedOption.value })}
                                    placeholder="Select Colour"
                                />
                            </FormGroup>
                        </Col>
                        {/* <Col md="6">
                            <FormGroup>
                                <Label>Camera Brand</Label>
                                <Select 
                                    options={cameraBrandOptions} 
                                    value={cameraBrandOptions.find(option => option.value === formData.camera_brand)}
                                    onChange={selectedOption => setformData({ ...formData, camera_brand: selectedOption.value })}
                                    placeholder="Select Camera Brand"
                                />
                            </FormGroup>
                        </Col>  */}
                        <Col md='6'>
                            <FormGroup  >
                                <Label>No. OF Person</Label>
                                <Input type="number" name="people" value={formData?.people} onChange={(e) => handleInput(e)} />
                            </FormGroup>
                        </Col>
                        <Col md='6'>
                            <FormGroup  >
                                <Label>Frequency(mins)</Label>
                                <Input type="number" name="freq" value={formData?.freq} onChange={(e) => handleInput(e)} />
                            </FormGroup>
                        </Col>
                        <Col md='6'>
                            <FormGroup>
                                <Label>Non-Compliance</Label>
                                <Input type="number" name="alert" value={formData?.alert} onChange={(e) => handleInput(e)} />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                                <FormGroup>
                                    <Label>Alerts Level</Label>
                                    <Select 
                                        options={levelOptions} 
                                        value={levelOptions.find(option => option.value === formData.level)}
                                        onChange={selectedOption => setformData({ ...formData, level: selectedOption.value })}
                                        placeholder="Select Level"
                                    />
                                </FormGroup>
                            </Col>
                        <Col md='6'>
                        <FormGroup className="flex-grow-1">
                            <Label>ROI</Label>
                            <Select
                                isMulti
                                options={roiOptions}
                                value={formData.roi}
                                onChange={handleROIChange}
                                placeholder="Select ROI"
                            />
                        </FormGroup>
                        </Col>

                    </Row>

                </Form>
            </ModalBody>
            <ModalFooter>
                {/* <Button color="secondary" onClick={toggle}>Cancel</Button> */}
                <Button color="primary" onClick={()=>{handleSaveINFO()}}>Save Changes</Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditAreaModal;
